import React from 'react';
import {clientLogger} from 'shared/logger/clientLogger.ts';

export class ErrorBoundary extends React.Component<
  {children: React.ReactNode},
  {hasError: boolean}
> {
  state = {hasError: false};

  static getDerivedStateFromError() {
    return {hasError: true};
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    clientLogger.log({
      type: 'ui',
      severity: 'error',
      message: error.message,
      stack: error.stack,
      meta: {componentStack: info.componentStack},
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{padding: 24}}>
          <h2>Something went wrong</h2>
          <p>Try reloading the page.</p>
        </div>
      );
    }
    return this.props.children;
  }
}
